import { observer } from "mobx-react";
import React, { Component } from "react";
import styled from "styled-components";
import CheckboxGroup from "../../form/CheckboxGroup";
import Checkbox from "../../form/Checkbox";
import FilterGroup from "../FilterGroup";

const Hr = styled.hr`
  border-top: 1px dashed rgba(0, 0, 0, 0.54);
`;

class PitchTypeFilter extends Component {
  render() {
    const { store } = this.props;

    return (
      <FilterGroup title="Pitch Types">
        <CheckboxGroup
          checked={store.pitchTypes}
          onChangeHandler={store.updatePitchTypes}
        >
          <Checkbox value="FF" label="Four-seam Fastball" />
          <Checkbox value="FT" label="Two-seam Fastball" />
          <Checkbox value="SI" label="Sinker" />
          <Checkbox value="FC" label="Cutter" />
          <Hr />
          <Checkbox value="CH" label="Changeup" />
          <Checkbox value="FS" label="Splitter" />
          <Checkbox value="FO" label="Forkball" />
          <Checkbox value="SC" label="Screwball" />
          <Hr />
          <Checkbox value="SL" label="Slider" />
          <Checkbox value="GY" label="Gyroball" />
          <Checkbox value="CU" label="Curveball" />
          <Checkbox value="KC" label="Knuckle Curve" />
          <Checkbox value="KN" label="Knuckleball" />
          <Checkbox value="EP" label="Eephus Pitch" />
          <Hr />
          <Checkbox value="AS" label="Automatic Strike" />
          <Checkbox value="AB" label="Automatic Ball" />
          <Checkbox value="IN" label="Intentional Ball" />
          <Checkbox value="PO" label="Pitchout" />
          <Checkbox value="NP" label="No Pitch" />
        </CheckboxGroup>
      </FilterGroup>
    );
  }
}

export default observer(PitchTypeFilter);



// WEBPACK FOOTER //
// ./src/components/filters/options/PitchTypeFilter.js